export const MIN_FREQ = 1;
export const MAX_FREQ = 15000;

export const PLAY_TONE_TEXT = "Ton abspielen";
export const STOP_TONE_TEXT = "Stoppen";
export const PLAY_SEQ_TEXT = "Neuromodulation abspielen";
export const STOP_SEQ_TEXT = "Neuromodulation stoppen";

export const VOLUME_KEY = "Lautstärke";
export const FREQ_KEY = "Frequenz";
export const PLAYER_STATE_KEY = "playerState";

// initial config values
export const DEFAULT_FREQ = 1000;
export const DEFAULT_VOLUME = -10;

export const LOOP_REPEAT = 4;
export const REST_LENGTH = 4;

// constants
export const PLAYER_STATES = {
    PLAY_TONE: 0,
    PLAY_ACRN: 1
};



// WEBPACK FOOTER //
// ./src/constants.js